import { render, staticRenderFns } from "./SacTreatmentsByPage.vue?vue&type=template&id=3a5b270d&"
import script from "./SacTreatmentsByPage.vue?vue&type=script&lang=js&"
export * from "./SacTreatmentsByPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports